import ReactDOM from 'react-dom/client';
import App from './App';
import '../src/theme/main.css'
import { registerServiceWorker } from './serviceWorkerRegistration';

const EXTENSION_AUTOFILL_SCRIPT = 'bootstrap-autofill-overlay.js';
const EXTENSION_AUTOFILL_ERROR = "Cannot read properties of null (reading 'includes')";

function includesAutofillScript(text) {
  return typeof text === 'string' && text.includes(EXTENSION_AUTOFILL_SCRIPT);
}

function includesKnownAutofillMessage(text) {
  return typeof text === 'string' && text.includes(EXTENSION_AUTOFILL_ERROR);
}

function isKnownAutofillOverlayError(reason) {
  if (typeof reason === 'string') {
    return includesAutofillScript(reason) || includesKnownAutofillMessage(reason);
  }

  const message = reason?.message || '';
  const stack = reason?.stack || '';

  return includesAutofillScript(message)
    || includesAutofillScript(stack)
    || includesKnownAutofillMessage(message)
    || includesKnownAutofillMessage(stack);
}

window.addEventListener('error', (event) => {
  const source = event?.filename || '';
  const message = event?.message || '';

  if (includesAutofillScript(source) || isKnownAutofillOverlayError(message)) {
    event.preventDefault();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (isKnownAutofillOverlayError(event?.reason)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

registerServiceWorker();

/* <React.StrictMode>
    <App />
  </React.StrictMode> */